import Grid from "@mui/material/Grid";

import useMediaQuery from '@mui/material/useMediaQuery';

import styles from './estilos.module.css';

import logo from '../../assets/img/otros/logotipo-blanco.png';

/*import facebook from '../../assets/icons/facebook.png';
import linkedin from '../../assets/icons/linkedin.png';
import whatsapp from '../../assets/icons/whatsapp.png';*/
import {HashLink as Link} from "react-router-hash-link";

import { FooterResp } from "../../interfaces/footer";
import { useEffect, useState } from "react";
import { useFetch, useURL } from "../../hooks";

export const Footer = () => {
    const [columnaServicios,setColumnaServicios] = useState<FooterResp | null>(null); 
    const [columnaOsania,setColumnaOsania] = useState<FooterResp | null>(null);
    const [columnaContactanos,setColumnaContactanos] = useState<FooterResp | null>(null);  

    const { peticion } = useFetch();
    const url = useURL();

    useEffect(() => {
        peticion(`${url}/footer`).subscribe((value)=>{
            setColumnaServicios(getById(383,value));
            setColumnaOsania(getById(384,value));
            setColumnaContactanos(getById(385,value));
        });
    },[]);

    const getById = (id: number,arr: FooterResp[]) => {
        const res = arr.filter((item)=>item.id===id);
        return res&&res.length>0?res[0]:null;
    }

    const matches = useMediaQuery('(max-width:600px)');
    return (
        <footer>
            <Grid container spacing={2} sx={{
                backgroundColor: '#2d2d2d',
                height: matches ? 'auto' : 470,
                paddingBottom: matches ? '20px' : 0
            }}>

                <Grid item xl={1} lg={1} xs={1}></Grid>

                {
                    //Footer responsivo
                    matches && <>
                        <Grid container item xs={4}>
                            <Grid item xl={1} lg={1} xs={12}>
                                <h3 className={styles.h3}>{columnaServicios?.acf.titulo}</h3>
                                <Link to={columnaServicios?.acf.elemento_1?.enlace||''} className={`${styles.p} ${styles.link}`}>
                                    {columnaServicios?.acf.elemento_1?.texto}
                                </Link>
                                <Link to={columnaServicios?.acf.elemento_2?.enlace||''} className={`${styles.p} ${styles.link}`}>
                                    {columnaServicios?.acf.elemento_2?.texto}
                                </Link>
                            </Grid>
                            <Grid item xl={1} lg={1} xs={12}>
                                <h3 className={styles.h3}>{columnaOsania?.acf.titulo}</h3>
                                <Link to={columnaOsania?.acf.elemento_1?.enlace||''} className={`${styles.p} ${styles.link}`}>
                                    {columnaOsania?.acf.elemento_1?.texto}
                                </Link>
                                <Link to={columnaOsania?.acf.elemento_2?.enlace||''} className={`${styles.p} ${styles.link}`}>
                                    {columnaOsania?.acf.elemento_2?.texto}
                                </Link>
                                <Link to={columnaOsania?.acf.elemento_3?.enlace||''} className={`${styles.p} ${styles.link}`}>
                                    {columnaOsania?.acf.elemento_3?.texto}
                                </Link>
                                <a href={columnaOsania?.acf.elemento_4?.enlace||''} rel="noreferrer" target="_blank" className={`${styles.p} ${styles.link}`}>
                                    {columnaOsania?.acf.elemento_4?.texto}
                                </a>
                            </Grid>
                        </Grid>
                    </>
                }

                {
                    //Footer no responsivo
                    !matches && <>
                        <Grid item xl={1} lg={1} xs={2}>
                            <Link to={columnaServicios?.acf.enlace_titulo||''} className={`${styles.link}`}>
                                <h3 className={styles.h3}>{columnaServicios?.acf.titulo}</h3>
                            </Link>
                            <Link to={columnaServicios?.acf.elemento_1?.enlace||''} className={`${styles.p} ${styles.link}`}>
                                {columnaServicios?.acf.elemento_1?.texto}
                            </Link><br/><br/>
                            <Link to={columnaServicios?.acf.elemento_2?.enlace||''} className={`${styles.p} ${styles.link}`}>
                                {columnaServicios?.acf.elemento_2?.texto}
                            </Link>
                        </Grid>

                        <Grid item xl={1} lg={1} xs={1}></Grid>

                        <Grid item xl={1} lg={1} xs={2}>
                            <h3 className={styles.h3}>{columnaOsania?.acf.titulo}</h3>
                            <Link to={columnaOsania?.acf.elemento_1?.enlace||''} className={`${styles.p} ${styles.link}`}>
                                {columnaOsania?.acf.elemento_1?.texto}
                            </Link><br/><br/>
                            <Link to={columnaOsania?.acf.elemento_2?.enlace||''} className={`${styles.p} ${styles.link}`}>
                                {columnaOsania?.acf.elemento_2?.texto}
                            </Link><br/><br/>
                            <Link to={columnaOsania?.acf.elemento_3?.enlace||''} className={`${styles.p} ${styles.link}`}>
                                {columnaOsania?.acf.elemento_3?.texto}
                            </Link><br/><br/>
                            <a href={columnaOsania?.acf.elemento_4?.enlace||''} rel="noreferrer" target="_blank" className={`${styles.p} ${styles.link}`}>
                                {columnaOsania?.acf.elemento_4?.texto}
                            </a>
                        </Grid>
                    </>
                }

                <Grid item xl={5} lg={5} xs={1}></Grid>

                {matches && <Grid item xl={3} lg={3} xs={1}></Grid>}

                <Grid item xl={2} lg={2} xs={5}>
                    <h3 className={`${styles.h3}`}>{columnaContactanos?.acf.titulo}</h3>
                    <a href={"tel:"+(columnaContactanos?.acf.telefono_1||'')} rel="noreferrer" target="_blank" className={`${styles.p} ${styles.link}`}>
                        {columnaContactanos?.acf.telefono_1}
                    </a><br/><br/>
                    <a href={"tel:"+(columnaContactanos?.acf.telefono_2||'')} rel="noreferrer" target="_blank" className={`${styles.p} ${styles.link}`}>
                        {columnaContactanos?.acf.telefono_2}
                    </a>
                    <p className={`${styles.p} ${styles['p-whatsapp']}`}>
                        <a href={"https://api.whatsapp.com/send?phone="+columnaContactanos?.acf.whatsapp?.icono+"&text=Hola,%20me%20gustar%C3%ADa%20saber%20m%C3%A1s%20sobre%20Osania"} target="_blank" rel="noreferrer">
                            <img className={styles.icono} src={columnaContactanos?.acf.whatsapp?.icono} alt="" />
                        </a> {columnaContactanos?.acf.whatsapp?.telefono}
                    </p>
                    <p className={styles.p}>
                        <a className={styles.a} href={"mailto:"+columnaContactanos?.acf.email}>{columnaContactanos?.acf.email}</a>
                    </p>
                    <p className={styles.p}>{columnaContactanos?.acf.redes_sociales?.titulo}</p>

                    <div>
                        <a href={columnaContactanos?.acf.redes_sociales?.facebook.enlace} target="_blank" rel="noreferrer">
                            <img className={styles.icono} src={columnaContactanos?.acf.redes_sociales?.facebook.icono} alt="" />
                        </a>
                        <a href={columnaContactanos?.acf.redes_sociales?.linkedin.enlace} target="_blank" rel="noreferrer">
                            <img className={styles.icono} src={columnaContactanos?.acf.redes_sociales?.linkedin.icono} alt="" />
                        </a>

                    </div>
                </Grid>

                <Grid item xl={1} lg={1} xs={1}></Grid>
            </Grid>
            <Grid container spacing={2} sx={{
                backgroundColor: '#1a1a1a',
                height: matches ? 'auto' : 247,
            }}>
                <Grid item xl={1} lg={1} xs={1}></Grid>

                <Grid item xl={3} lg={3} xs={5}>
                    <p className={`${styles.p} ${styles.derechos}`}>©OSANIA Todos los derechos reservados.</p>
                </Grid>

                <Grid item xl={5} lg={5} xs={1}></Grid>

                <Grid item xl={2} lg={2} xs={4}>
                    <img className={styles.logo} src={logo} alt="" />
                </Grid>

                <Grid item xl={1} lg={1} xs={1}></Grid>
            </Grid>
        </footer>
    )
}
